const original = window.localStorage.setItem.bind(window.localStorage);
window.localStorage.setItem = (key: string, value: string) => {
  original(key, value);
  if (key === 'featureFlags') {
    window.location.reload();
  }
};
